import { useState } from "react";
import { StyleSheet, Text, View } from "react-native";
import Svg, { Defs, LinearGradient, Rect, Stop } from "react-native-svg";
import Icon from "react-native-vector-icons/MaterialCommunityIcons";
import { formatMoneyBRL } from "../../../helpers/util";
import * as Colors from "../../../styles/colors";
import * as Fonts from "../../../styles/typography";

export default function WalletCredit({
  credit = 0,
  walletShared,
  onPressDelete,
  onPressInfo
}) {
  const [showValue, setShowValue] = useState(false)

  return (
    <View style={style.walletView}>
      <Svg height="100%" width="100%" style={StyleSheet.absoluteFillObject}>
        <Defs>
          <LinearGradient id="grad" x1="100%" y1="0%" x2="100%" y2="100%">
            <Stop offset="0" stopColor={Colors.PRIMARY} />
            <Stop offset="1" stopColor={Colors.SECONDARY} />
          </LinearGradient>
        </Defs>
        <Rect width="100%" height="100%" fill="url(#grad)" rx={8} />
      </Svg>
      <View style={{ justifyContent: "space-between", }}>
        <View style={{ marginHorizontal: 24 }}>
          <View style={{ flexDirection: "row", alignItems: "center" }}>
            <Text style={style.textYouHave}>{"SEU BALANÇO"}</Text>
            <Icon
              name={showValue ? "eye-outline" : "eye-off-outline"}
              color={Colors.WHITE}
              size={24}
              style={{ marginLeft: "auto" }}
              onPress={() => setShowValue(!showValue)}
            />
          </View>
          {/* <View
            style={{
              flexDirection: "row",
              alignItems: "center",
            }}
          > */}
            <Text style={style.textCredit} adjustsFontSizeToFit={true} numberOfLines={1}>
              {showValue ? formatMoneyBRL(credit) : "****"}
            </Text>
          {/* </View> */}
        </View>

        {!!walletShared.nameUser ? (
          <View
            style={{
              marginHorizontal: 24,
              borderWidth: 0.5,
              borderColor: Colors.WHITE,
              borderRadius: 8,
              padding: 5,
              marginTop: 8,
            }}
          >
            <View style={{ flexDirection: "row", alignItems: "center" }}>
              <Text style={style.sharedWalletText}>{"COMPARTILHADO"}</Text>
              <Icon
                name={"information-outline"}
                color={Colors.WHITE}
                size={24}
                style={{ marginLeft: "auto" }}
                onPress={onPressInfo}
              />
              <Icon
                name={"trash-can-outline"}
                color={Colors.WHITE}
                size={24}
                style={{ marginLeft: 4 }}
                onPress={onPressDelete}
              />
            </View>
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <Text style={style.sharedWalletValueText}>
                {formatMoneyBRL(walletShared.value)}
              </Text>
            </View>
          </View>
        ) : null}

        {/* <TouchableOpacity style={style.walletSeal}>
          <ButtonIcon
            iconName={"share-variant-outline"}
            onPress={() => onPressShare()}
          />
        </TouchableOpacity> */}
      </View>
    </View>
  );
}

const style = StyleSheet.create({
  walletView: {
    width: "100%",
    height: 200,
    backgroundColor: Colors.SECONDARY_PALLETE[1],
    borderRadius: 12,
    marginVertical: 8,
    shadowColor: Colors.GRAY_DARK,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
    justifyContent: "center",
  },
  walletLineHorizontal: {
    backgroundColor: Colors.WHITE,
    width: "85%",
    height: 6,
    marginTop: 16,
    alignSelf: "flex-end",
    marginRight: 12,
    borderTopRightRadius: 32,
    borderTopLeftRadius: 32,
  },
  walletLineVertical: {
    backgroundColor: Colors.WHITE,
    width: 6,
    height: 16,
    alignSelf: "flex-end",
    marginRight: 12,
  },
  walletSeal: {
    width: "20%",
    height: "60%",
    alignSelf: "center",
    borderWidth: 6,
    // borderRightWidth: 0,
    borderColor: Colors.WHITE,
    borderTopLeftRadius: 12,
    borderBottomLeftRadius: 12,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: Colors.WALLET,
  },
  walletPin: {
    width: 24,
    height: 24,
    backgroundColor: Colors.WALLET,
    borderRadius: 64,
    borderWidth: 5,
    borderColor: Colors.WHITE,
  },
  textYouHave: {
    fontSize: Fonts.FONT_SIZE_28,
    color: Colors.WHITE,
    fontWeight: "500",
  },
  textCredit: {
    fontSize: 48,
    color: Colors.WHITE,
    fontWeight: "bold",
    marginLeft: 8,
  },
  textCreditLabel: {
    fontSize: Fonts.FONT_SIZE_20,
    color: Colors.WHITE,
    marginLeft: 8,
    alignSelf: "flex-end",
  },
  sharedWalletView: {
    flexDirection: "row",
    backgroundColor: Colors.WALLET_SECONDARY,
    borderRadius: 8,
    paddingHorizontal: 8,
    paddingVertical: 4,
    marginHorizontal: 8,
    marginTop: 4,
    borderWidth: 2,
    borderColor: Colors.WHITE,
    alignItems: "center",
  },
  sharedWalletText: {
    marginRight: 4,
    color: Colors.WHITE,
    fontSize: Fonts.FONT_SIZE_16,
    fontWeight: "500",
  },
  sharedWalletValueText: {
    color: Colors.WHITE,
    fontSize: Fonts.FONT_SIZE_18,
    fontWeight: "bold",
  },
});
